import { Routes } from '@angular/router';

export const cardListRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./card-list.page').then((m) => m.CardListPage),
  },
];
